import { render } from "./App.vue?vue&type=template&id=867f0162"
const script = {}

import "./App.vue?vue&type=style&index=0&id=867f0162&lang=scss"

import exportComponent from "/builds/snedson/snedson-auth-backend/snedson-auth-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__